import script from "./MenuUsuario.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuUsuario.vue?vue&type=script&setup=true&lang=js"

import "./MenuUsuario.vue?vue&type=style&index=0&id=136b8bc5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-136b8bc5"]])

export default __exports__